import React, { useEffect } from "react";
import clsx from "clsx";
import Selector from "./selector/Selector";
import globalStyles from "../../../shared-components/css-modules/lexus/styles/global.module.scss";
import styles from "./Gradeselector.module.scss";
import { MODAL_DEBUG_FINANCE } from "../../utils/modalConstants";
import {
    POSTAL_CHANNEL_T1_FINANCE,
    POSTAL_TOPIC_UPDATE_DISCLAIMERTABLE,
} from "../../../../../common-deprecated/constants";
import useDataFetcher from "../../../../../common-deprecated/hooks/useDataFetcher";
import type { GetFetchesFnType } from "../../../../../common-deprecated/utils/registryTypes";
import { COMPONENT_GRADE_SELECTOR } from "../../../../../shared-logic/server/components";
import { getGradeSelectorComponentFetches, gradeSelectorFetchDispatcher } from "../../datafetch/fetchUtils";
import useStatus from "../../../../../common-deprecated/hooks/useStatus";
import { useGradeSelectorSelector } from "../../redux/hooks";
import useDisclaimerContent from "../../hooks/useDisclaimerContent";
import { postalPublish } from "../../../../../common-deprecated/utils/postalUtils";
import { RequestStatusEnum } from "../../../../../common-deprecated/types/CommonTypes";
import { getRetailerDebugToggleLink } from "../../../../../common-deprecated/utils";

const GradeSelectorBase = (): JSX.Element => {
    const commonSettings = useGradeSelectorSelector((state) => state.commonSettings);
    const disclaimerData = useDisclaimerContent();
    const financeIsLoading = useGradeSelectorSelector(
        (state) => state.gradeSelectorFinance.state === RequestStatusEnum.Fetching,
    );

    useEffect(() => {
        postalPublish({
            channel: POSTAL_CHANNEL_T1_FINANCE,
            topic: POSTAL_TOPIC_UPDATE_DISCLAIMERTABLE,
            data: disclaimerData?.minMax || {},
        });
    }, [disclaimerData?.minMax]);

    useStatus(
        commonSettings,
        commonSettings.component,
        [getRetailerDebugToggleLink()],
        [{ key: "f", settings: { type: MODAL_DEBUG_FINANCE } }],
    );

    // This makes the component refetch its data when finance failed to fetch swiftly
    useDataFetcher(
        getGradeSelectorComponentFetches() as unknown as GetFetchesFnType,
        gradeSelectorFetchDispatcher,
        COMPONENT_GRADE_SELECTOR,
        [financeIsLoading],
        [],
    );

    return (
        <div className={clsx(globalStyles.global, styles.gradeselector)}>
            <Selector />
        </div>
    );
};

export default GradeSelectorBase;
